var _circle, _path, _rect, _rect2, _circle2, _rect3, _circle3, _path2, _rect4, _g, _rect5, _path3, _rect6, _rect7, _rect8, _path4, _g2, _circle4, _rect9, _path5, _path6, _path7, _rect0, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 240,
    viewBox: "0 0 300 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 120,
    r: 120,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.471 77.2249L204.482 77.2249C207.742 77.2249 210.385 79.8679 210.385 83.1283V156.727C210.385 159.988 207.742 162.631 204.482 162.631L95.7159 162.631C92.4556 162.631 89.8125 159.988 89.8125 156.727L89.8125 83.1283C89.8125 83.1093 89.8126 83.0903 89.8128 83.0713L89.8128 75.2784C89.8128 72.0181 92.4558 69.375 95.7162 69.375L143.568 69.375C146.828 69.375 149.471 72.0181 149.471 75.2784V77.2249Z",
    fill: "#004699"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.8568,
    y: 74.419,
    width: 79.1259,
    height: 56.5185,
    rx: 5.06692,
    fill: "#F5F6FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.8568,
    y: 74.419,
    width: 108.013,
    height: 56.5185,
    rx: 5.06692,
    fill: "#F5F6FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.63,
    cy: 83.1444,
    r: 4.22459,
    fill: "#DBDEE7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.405,
    y: 93.5847,
    width: 26.8701,
    height: 31.0775,
    rx: 2.11121,
    fill: "#DBDEE7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.834,
    cy: 104.741,
    r: 6.1411,
    fill: "#18223D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.826 123.853C126.44 124.346 125.839 124.662 125.164 124.662H102.517C101.828 124.662 101.217 124.333 100.832 123.823C102.369 118.087 107.604 113.863 113.825 113.863C120.057 113.863 125.299 118.102 126.826 123.853Z",
    fill: "#18223D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.696,
    y: 79.4429,
    width: 81.6378,
    height: 7.5358,
    rx: 3.7679,
    fill: "#DBDEE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.594,
    y: 94.2005,
    width: 43.5938,
    height: 6.64135,
    rx: 3.32067,
    fill: "#B4BACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.594,
    y: 107.483,
    width: 43.5938,
    height: 6.64135,
    rx: 3.32067,
    fill: "#B4BACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.594,
    y: 120.766,
    width: 43.5938,
    height: 6.64135,
    rx: 3.32067,
    fill: "#B4BACA"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8531,
    y: 84.4464,
    width: 120.573,
    height: 85.4057,
    rx: 5.90342,
    fill: "url(#paint0_linear_194_3577)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.119 142.632C159.352 142.632 166.837 135.147 166.837 125.914C166.837 116.681 159.352 109.196 150.119 109.196C140.886 109.196 133.401 116.681 133.401 125.914C133.401 135.147 140.886 142.632 150.119 142.632ZM158.444 122.482C159.059 121.863 159.056 120.864 158.438 120.249C157.819 119.634 156.82 119.637 156.205 120.255L147.608 128.901L144.761 126.037C144.146 125.418 143.146 125.416 142.528 126.03C141.909 126.645 141.906 127.645 142.521 128.263L146.444 132.209C147.086 132.854 148.131 132.854 148.773 132.209L158.444 122.482Z",
    fill: "url(#paint1_linear_194_3577)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9375,
    y: 156.562,
    width: 59.0625,
    height: 42.1875,
    rx: 3.21863,
    fill: "#F5F6FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9375,
    y: 156.562,
    width: 59.0625,
    height: 42.1875,
    rx: 3.21863,
    fill: "#D6DEE1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.0796,
    y: 170.868,
    width: 20.0568,
    height: 23.1974,
    rx: 1.3411,
    fill: "#B4BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1031 183.78C89.6347 183.78 91.687 181.727 91.687 179.196C91.687 176.664 89.6347 174.612 87.1031 174.612C84.5714 174.612 82.5191 176.664 82.5191 179.196C82.5191 181.727 84.5714 183.78 87.1031 183.78ZM95.7958 194.066C96.2126 194.066 96.5851 193.875 96.831 193.577C95.7311 189.225 91.79 186.005 87.0967 186.005C82.4114 186.005 78.4756 189.215 77.3679 193.555C77.6135 193.866 77.994 194.066 78.4211 194.066H95.7958Z",
    fill: "#0E1214"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 100.359,
    y: 171.328,
    width: 27.6919,
    height: 4.21875,
    rx: 2.10938,
    fill: "#001733"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 100.359,
    y: 179.766,
    width: 27.6919,
    height: 4.21875,
    rx: 2.10938,
    fill: "#001733"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 100.359,
    y: 188.203,
    width: 27.6919,
    height: 4.21875,
    rx: 2.10938,
    fill: "#001733"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 80.2327,
    cy: 163.075,
    r: 3.15339,
    fill: "#929EA9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 87.5906,
    y: 159.922,
    width: 41.1029,
    height: 5.79935,
    rx: 2.89967,
    fill: "#929EA9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.386 85.471L184.031 96.7571V79.846V72.8147V46.096C184.031 42.9894 186.55 40.471 189.656 40.471H223.406C226.513 40.471 229.031 42.9894 229.031 46.096V79.846C229.031 82.9526 226.513 85.471 223.406 85.471H192.386Z",
    fill: "#D6DEE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.672 53.6802C202.055 52.5318 203.13 51.7571 204.34 51.7571H208.724C209.934 51.7571 211.009 52.5318 211.392 53.6802L212.157 55.9759H217.782C219.335 55.9759 220.594 57.2351 220.594 58.7884V72.8509C220.594 74.4042 219.335 75.6634 217.782 75.6634H195.282C193.729 75.6634 192.469 74.4042 192.469 72.8509V58.7884C192.469 57.2351 193.729 55.9759 195.282 55.9759H200.907L201.672 53.6802ZM209.344 60.1946L209.346 60.1946C210.121 60.1955 210.75 60.8248 210.75 61.6009C210.75 62.3775 210.121 63.0071 209.344 63.0071C208.567 63.0071 207.938 62.3775 207.938 61.6009C207.938 60.8248 208.566 60.1955 209.342 60.1946L209.344 60.1946ZM203.719 60.1946L203.721 60.1946C204.496 60.1955 205.125 60.8248 205.125 61.6009C205.125 62.3775 204.496 63.0071 203.719 63.0071C202.942 63.0071 202.313 62.3775 202.313 61.6009C202.313 60.8248 202.941 60.1955 203.717 60.1946L203.719 60.1946ZM210.75 65.8196C211.527 65.8196 212.174 66.4588 211.981 67.2113C211.734 68.1816 211.229 69.077 210.509 69.7971C209.454 70.852 208.023 71.4446 206.531 71.4446C205.04 71.4446 203.609 70.852 202.554 69.7971C201.834 69.077 201.329 68.1816 201.081 67.2113C200.889 66.4588 201.536 65.8196 202.313 65.8196H206.531H210.75ZM216.376 51.7571C215.599 51.7571 214.969 52.3867 214.969 53.1634V54.5696H217.782V53.1634C217.782 52.3867 217.152 51.7571 216.376 51.7571Z",
    fill: "#0E1214"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.757 58.9872C166.956 58.691 166.956 57.559 167.757 57.2628L170.398 56.2852C170.65 56.1921 170.848 55.9937 170.941 55.7421L171.919 53.1003C172.215 52.2999 173.347 52.2999 173.643 53.1003L174.621 55.7421C174.714 55.9937 174.913 56.1921 175.164 56.2852L177.806 57.2628C178.606 57.559 178.606 58.691 177.806 58.9872L175.164 59.9648C174.913 60.0579 174.714 60.2563 174.621 60.5079L173.643 63.1497C173.347 63.9501 172.215 63.9501 171.919 63.1497L170.941 60.5079C170.848 60.2563 170.65 60.0579 170.398 59.9648L167.757 58.9872Z",
    fill: "#0075FF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 220.594,
    y: 100.071,
    width: 5.625,
    height: 5.625,
    rx: 1.40625,
    transform: "rotate(-45 220.594 100.071)",
    fill: "#0075FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_3577",
    x1: 172.706,
    y1: 148.98,
    x2: 126.86,
    y2: 72.8344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F58EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24A5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_194_3577",
    x1: 134.794,
    y1: 113.838,
    x2: 175.12,
    y2: 132.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493056,
    stopColor: "#38EF5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02CCCD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.232bd793d157cf2c9866c870b0e93a72.svg";
export { ForwardRef as ReactComponent };